import React, { useState } from 'react';
import { Card, Form, InputNumber, Input, Button, message, Space } from 'antd';
import api from '../../services/api';

export default function SaudePage() {
  const [form] = Form.useForm();
  const [formLoad] = Form.useForm();
  const [ficha, setFicha] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregar = async (values) => {
    try {
      setLoading(true);
      const res = await api.get(`/creche/saude/${values.estudanteId}`);
      setFicha(res.data || null);
      message.success('Ficha carregada');
    } catch (e) {
      message.error('Não foi possível carregar a ficha');
    } finally {
      setLoading(false);
    }
  };

  const salvar = async (values) => {
    try {
      const payload = {
        estudanteId: values.estudanteId,
        alergias: values.alergias ? JSON.parse(values.alergias) : [],
        vacinas: values.vacinas ? JSON.parse(values.vacinas) : [],
        medicacao: values.medicacao ? JSON.parse(values.medicacao) : [],
        contactoMedico: values.contactoMedico || '',
        observacoes: values.observacoes || '',
      };
      await api.post('/creche/saude', payload);
      message.success('Ficha de saúde guardada');
    } catch (e) {
      message.error('Erro ao guardar ficha. Verifique o formato dos campos JSON');
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <Space direction="vertical" style={{ width: '100%' }} size="large">
        <Card title="Carregar Ficha">
          <Form layout="inline" form={formLoad} onFinish={carregar}>
            <Form.Item name="estudanteId" label="ID Estudante" rules={[{ required: true }]}>
              <InputNumber min={1} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>Carregar</Button>
            </Form.Item>
          </Form>
          {ficha && (
            <pre className="mt-4 bg-gray-100 p-3 rounded">{JSON.stringify(ficha, null, 2)}</pre>
          )}
        </Card>

        <Card title="Guardar/Atualizar Ficha de Saúde">
          <Form layout="vertical" form={form} onFinish={salvar}>
            <Form.Item name="estudanteId" label="ID Estudante" rules={[{ required: true }]}><InputNumber min={1} /></Form.Item>
            <Form.Item name="alergias" label="Alergias (JSON)"><Input.TextArea rows={3} placeholder='Ex.: ["amendoim","poeira"]' /></Form.Item>
            <Form.Item name="vacinas" label="Vacinas (JSON)"><Input.TextArea rows={3} placeholder='Ex.: ["BCG","Sarampo"]' /></Form.Item>
            <Form.Item name="medicacao" label="Medicação (JSON)"><Input.TextArea rows={3} placeholder='Ex.: ["paracetamol"]' /></Form.Item>
            <Form.Item name="contactoMedico" label="Contacto Médico"><Input /></Form.Item>
            <Form.Item name="observacoes" label="Observações"><Input.TextArea rows={3} /></Form.Item>
            <Button type="primary" htmlType="submit">Guardar</Button>
          </Form>
        </Card>
      </Space>
    </div>
  );
}
